import { render, staticRenderFns } from "./RelationUser.vue?vue&type=template&id=27fe44f9&scoped=true"
import script from "./RelationUser.vue?vue&type=script&lang=js"
export * from "./RelationUser.vue?vue&type=script&lang=js"
import style0 from "./RelationUser.vue?vue&type=style&index=0&id=27fe44f9&prod&lang=scss&scoped=true"
import style1 from "./RelationUser.vue?vue&type=style&index=1&id=27fe44f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe44f9",
  null
  
)

export default component.exports